import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {Platform} from '../constants/Platform';
import {environment} from '../../../../../environments/environment';
import {AppName} from '../constants/AppName';

@Injectable({
  providedIn: 'root'
})
export class NonAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.auth()) {
      return true;
    }
    this.router.navigate([route.data['app'] == Platform.MICROSOFT ? '/panel' : (environment.appName == AppName.MODULIX ? '/programs' : '/projects')]);
    return false;
  }
}
